import { Answer as MultipleChoiceAnswer } from "../../multiplechoice/types";
import { markAnswer as markWordfillAnswer } from "../../wordfill/logic/answers";
import {
  Answer as WordfillAnswer,
  Content as WordfillContent
} from "../../wordfill/types";
import { Answer, Content, Score } from "../types";

export function markAnswer(content: Content, answer: Answer): Score {
  switch (content.testingType) {
    case "MULTIPLE_CHOICE":
      return markMultipleChoice(content, answer);

    case "WORDFILL":
      return markWordfill(content, answer);

    default:
      return null as unknown as Score;
  }
}

function markMultipleChoice(content: Content, answer: Answer): Score {
  if (!answer || (answer as MultipleChoiceAnswer).index === null) {
    return {
      score: 0
    };
  } else {
    return {
      score:
        (answer as MultipleChoiceAnswer).index === content.correctAnswerIndex
          ? 1
          : 0
    };
  }
}

function markWordfill(content: Content, answer: Answer): Score {
  return markWordfillAnswer(
    content as unknown as WordfillContent,
    answer as unknown as WordfillAnswer
  );
}
